var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.61176V19.1529C5 19.4824 5.16471 19.8118 5.41176 20.0588C5.65882 20.3059 5.98824 20.4706 6.31765 20.4706H14.3882M14.8824 4V8.11765H19M15.2941 4H9.61176C9.28235 4 8.95294 4.16471 8.70588 4.41176C8.45882 4.65882 8.29412 4.98824 8.29412 5.31765V15.8588C8.29412 16.1882 8.45882 16.5176 8.70588 16.7647C8.95294 17.0118 9.28235 17.1765 9.61176 17.1765H17.6824C18.0118 17.1765 18.3412 17.0118 18.5882 16.7647C18.8353 16.5176 19 16.1882 19 15.8588V7.70588L15.2941 4Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/Files.dc854e75ef7729c5d4dc53e37632da0c.svg";
export { ForwardRef as ReactComponent };